<p-toast></p-toast>

<div class="board-header">
  <div class="board-header-left">
    <h2 class="board-title">Guest Arrivals</h2>
    @if (lastRefreshed) {
      <span class="board-refresh-time">Updated {{ lastRefreshed | date:'h:mm a' }}</span>
    }
  </div>
  <div class="board-header-right">
    <span class="auto-label">Auto Mode</span>
    <p-inputSwitch [(ngModel)]="autoMode" (onChange)="toggleAutoMode()" pTooltip="When ON, auto-sends arrival SMS to all GREEN units every 5 minutes"></p-inputSwitch>
    @if (autoMode) {
      <span class="auto-active-badge">AUTO ON</span>
    }
    <button pButton icon="pi pi-comments" label="AI Assistant" class="p-button-outlined p-button-sm ml-3" (click)="openAiPanel()"></button>
  </div>
</div>

<div class="legend-row">
  <span class="legend-chip green">GREEN — Ready to send (door code + Breezeway 100%)</span>
  <span class="legend-chip amber">AMBER — Cleaning in progress</span>
  <span class="legend-chip red">RED — Flagged (missing door code or manual hold)</span>
  <span class="legend-chip grey">GREY — Already sent / not applicable</span>
</div>

<p-table #pt [value]="reservations" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]"
  [totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple"
  selectionMode="single" [globalFilterFields]="['guestLastName','reservationId','orderId']"
  [filterDelay]="1000" [(selection)]="reservation" dataKey="reservationId"
  (onRowSelect)="onRowSelect($event)" [loading]="loading" [responsive]="true"
  styleClass="p-datatable-striped arrival-board-table">

  <ng-template pTemplate="caption">
    <div class="flex">
      <div class="mr-2">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input #global pInputText type="text" (input)="pt.filterGlobal($event.target.value, 'contains')" placeholder="Search" />
        </span>
        <button pButton label="Clear" class="ml-2 p-button-outlined" icon="pi pi-filter-slash" (click)="clear(pt);"></button>
      </div>
      <div class="d-block text-end">
        <button pButton pRipple class="p-button-text" style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;" (click)="reloadPage()">Clear Filters</button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width:60px;">Status</th>
      <th [pSortableColumn]="'reservationId'">Res #</th>
      <th [pSortableColumn]="'shortTermRentalVO.propertyCode'">Property</th>
      <th [pSortableColumn]="'guestProfileVO.lastName'">Guest</th>
      <th [pSortableColumn]="'checkInDateTime'">Arrival</th>
      <th [pSortableColumn]="'checkOutDateTime'">Departure</th>
      <th>Door Code</th>
      <th>Gate Code</th>
      <th>Breezeway</th>
      <th>Message</th>
      <th style="width:200px;">Actions</th>
    </tr>
    <tr>
      <th></th>
      <th>
        <input pInputText style="width:90px;" type="text" (input)="pt.filter($event.target.value, 'reservationId', 'contains')">
      </th>
      <th>
        <input pInputText style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'startsWith')">
      </th>
      <th>
        <input pInputText style="width:130px;" type="text" (input)="pt.filter($event.target.value, 'guestProfileVO.lastName', 'startsWith')">
      </th>
      <th><input pInputText style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'checkInDateTime', 'in')"></th>
      <th><input pInputText style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'checkOutDateTime', 'in')"></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr [ngClass]="'row-status-' + row.boardStatus.toLowerCase()">

      <!-- Status indicator -->
      <td>
        <span class="status-dot" [ngClass]="'dot-' + row.boardStatus.toLowerCase()"
          [pTooltip]="getStatusLabel(row.boardStatus)"></span>
      </td>

      <td>{{ row.reservationId }}</td>

      <td><strong>{{ row.propertyCode }}</strong></td>

      <td>{{ row.guestFirstName }} {{ row.guestLastName }}</td>

      <td style="white-space: nowrap;">{{ row.checkInDate | date:'MM/dd/yy EEE' }}</td>

      <td style="white-space: nowrap;">{{ row.checkOutDate | date:'MM/dd/yy EEE' }}</td>

      <td>
        @if (row.accessCodeFrontDoor) {
          <strong>{{ row.accessCodeFrontDoor }}</strong>
        } @else {
          <span class="missing-code">MISSING</span>
        }
      </td>

      <td>{{ row.accessCodeHoaGate }}</td>

      <!-- Breezeway status column -->
      <td>
        <div class="bw-status">
          @if (row.breezewayPct !== null) {
            <div class="bw-bar-outer">
              <div class="bw-bar-inner" [style.width]="row.breezewayPct + '%'"
                [ngClass]="{'bw-bar-complete': row.breezewayPct === 100}"></div>
            </div>
            <span class="bw-pct">{{ row.breezewayPct }}%</span>
          } @else {
            <span class="bw-loading">{{ row.breezewaySummary }}</span>
          }
        </div>
      </td>

      <!-- Message status column -->
      <td>
        @if (row.messageSentAt) {
          <span class="msg-sent">Sent {{ row.messageSentAt | date:'h:mm a' }}</span>
        } @else if (row.manualHold) {
          <span class="msg-held">Human Hold</span>
        } @else if (row.boardStatus === 'GREEN') {
          <span class="msg-pending-green">Ready</span>
        } @else if (row.boardStatus === 'AMBER') {
          <span class="msg-pending-amber">Holding</span>
        } @else {
          <span class="msg-flagged">Flagged</span>
        }
      </td>

      <!-- Actions column -->
      <td>
        <div class="action-btns">
          <!-- Send Now: available for GREEN rows or manual override of AMBER/RED -->
          @if (!row.messageSentAt) {
            <button pButton pRipple
              label="Send Now"
              icon="pi pi-send"
              class="p-button-sm p-button-success"
              [ngClass]="{'p-button-outlined': row.boardStatus !== 'GREEN'}"
              (click)="sendNow(row)"
              [pTooltip]="row.boardStatus === 'GREEN' ? 'Unit ready — send arrival SMS' : 'Override: send anyway'"
              style="margin-right:4px;">
            </button>
          }
          <!-- Manual hold toggle -->
          @if (!row.messageSentAt) {
            <button pButton pRipple
              [icon]="row.manualHold ? 'pi pi-lock-open' : 'pi pi-lock'"
              class="p-button-sm p-button-secondary p-button-outlined"
              (click)="toggleManualHold(row)"
              [pTooltip]="row.manualHold ? 'Remove hold' : 'Put on hold'"
              style="margin-right:4px;">
            </button>
          }
          <!-- Open SMS dialog (manual compose) -->
          <button pButton pRipple
            icon="pi pi-envelope"
            class="p-button-sm p-button-text"
            (click)="onOpenFormAdd(row)"
            pTooltip="Compose SMS">
          </button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="paginatorCenter">
    Showing {{ recordTotal < 1 ? 0 : (lazyLoadEvent?.first + 1) }} -
    {{ recordTotal > 0 ? ((lazyLoadEvent?.rows + lazyLoadEvent?.first) <= recordTotal ? (lazyLoadEvent?.rows + lazyLoadEvent?.first) : recordTotal) : 0 }}
    of {{ recordTotal ? recordTotal : 0 }}
  </ng-template>

</p-table>
